import { Component, OnInit } from '@angular/core';

export interface Achievement {
  id: number;
  title: string;
  issuer: string;
  year: string;
  description: string;
  technologies: string[];
  category: 'certification' | 'award' | 'course';
  link?: string;
  imageUrl?: string;
}

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {
  
  achievements: Achievement[] = [
    {
      id: 1,
      title: 'Certificación AWS Solutions Architect',
      issuer: 'Amazon Web Services',
      year: '2023',
      description: 'Certificación profesional en diseño e implementación de sistemas distribuidos escalables, altamente disponibles y tolerantes a fallos en AWS. Especialización en arquitecturas cloud-native y mejores prácticas de seguridad.',
      technologies: ['AWS', 'Cloud Architecture', 'Security', 'Scalability'],
      category: 'certification',
      link: '#'
    },
    {
      id: 2,
      title: 'Certificación Spring Professional',
      issuer: 'VMware - Spring Framework',
      year: '2022',
      description: 'Certificación avanzada en el desarrollo de aplicaciones empresariales con Spring Framework. Especialización en Spring Boot, Spring Security, Spring Data y mejores prácticas para arquitecturas de microservicios.',
      technologies: ['Spring Boot', 'Spring Security', 'Spring Data', 'Microservices'],
      category: 'certification',
      link: '#'
    },
    {
      id: 3,
      title: 'Premio a la Innovación Tecnológica',
      issuer: 'Cámara de Comercio',
      year: '2021',
      description: 'Reconocimiento por el desarrollo de soluciones tecnológicas innovadoras en el sector biométrico y automatización industrial. Premio otorgado por implementación exitosa de sistemas de seguridad avanzados.',
      technologies: ['Innovation', 'Biometrics', 'Security', 'Automation'],
      category: 'award',
      link: '#'
    },
    {
      id: 4,
      title: 'Certificación Azure DevOps',
      issuer: 'Microsoft Azure',
      year: '2020',
      description: 'Certificación en prácticas DevOps con Microsoft Azure, incluyendo CI/CD, gestión de infraestructura como código, monitoreo y optimización de aplicaciones en la nube.',
      technologies: ['Azure DevOps', 'CI/CD', 'Infrastructure as Code', 'Monitoring'],
      category: 'certification',
      link: '#'
    },
    {
      id: 5,
      title: 'Curso Avanzado de Angular',
      issuer: 'Google Developers',
      year: '2023',
      description: 'Curso especializado en desarrollo avanzado con Angular, incluyendo arquitectura modular, optimización de rendimiento, testing avanzado y mejores prácticas para aplicaciones enterprise.',
      technologies: ['Angular', 'TypeScript', 'RxJS', 'Testing', 'Performance'],
      category: 'course',
      link: '#'
    },
    {
      id: 6,
      title: 'Certificación Docker & Kubernetes',
      issuer: 'Linux Foundation',
      year: '2022',
      description: 'Certificación en containerización y orquestación de aplicaciones usando Docker y Kubernetes. Especialización en despliegue, escalado automático y gestión de microservicios.',
      technologies: ['Docker', 'Kubernetes', 'Containerization', 'Microservices'],
      category: 'certification',
      link: '#'
    }
  ];

  filteredAchievements: Achievement[] = [];
  selectedCategory: string = 'all';
  selectedYear: string = 'all';

  categories = [
    { value: 'all', label: 'Todos' },
    { value: 'certification', label: 'Certificaciones' },
    { value: 'award', label: 'Premios' },
    { value: 'course', label: 'Cursos' }
  ];

  years: string[] = [];

  constructor() { }

  ngOnInit(): void {
    this.filteredAchievements = [...this.achievements];
    this.extractYears();
  }

  private extractYears(): void {
    const uniqueYears = [...new Set(this.achievements.map(achievement => achievement.year))];
    this.years = ['all', ...uniqueYears.sort().reverse()];
  }

  filterByCategory(category: string): void {
    this.selectedCategory = category;
    this.applyFilters();
  }

  filterByYear(year: string): void {
    this.selectedYear = year;
    this.applyFilters();
  }

  private applyFilters(): void {
    let filtered = [...this.achievements];

    if (this.selectedCategory !== 'all') {
      filtered = filtered.filter(achievement => achievement.category === this.selectedCategory);
    }

    if (this.selectedYear !== 'all') {
      filtered = filtered.filter(achievement => achievement.year === this.selectedYear);
    }

    this.filteredAchievements = filtered;
  }

  openAchievement(achievement: Achievement): void {
    if (achievement.link && achievement.link !== '#') {
      window.open(achievement.link, '_blank');
    }
  }

  getCategoryIcon(category: string): string {
    switch (category) {
      case 'certification':
        return '🎓';
      case 'award':
        return '🏆';
      case 'course':
        return '📚';
      default:
        return '📄';
    }
  }

  getCategoryName(category: string): string {
    switch (category) {
      case 'certification':
        return 'Certificación';
      case 'award':
        return 'Premio';
      case 'course':
        return 'Curso';
      default:
        return 'Logro';
    }
  }

  trackByAchievement(index: number, achievement: Achievement): number {
    return achievement.id;
  }
}
